export const setStringArr = (
  arr: string[] | undefined,
  item: string | string[],
): string[] | null => {
  const current = arr ?? [];

  if (typeof item === 'string') {
    const newArr = !current.includes(item) ? [...current, item] : current.filter((c) => c !== item);
    return newArr?.length ? newArr : null;
  } else {
    // If arr already contains the items, remove them
    if (item.every((i) => current.includes(i))) {
      const finalArr = current.filter((c) => !item.includes(c));
      return finalArr?.length ? finalArr : null;
    }

    // Otherwise, add the items that are not in the arr
    const newArr = item.filter((i) => !current.includes(i));

    const finalArr = [...current, ...newArr];
    return finalArr?.length ? finalArr : null;
  }
};
